export const BE_SERVER_ENDPOINT = "ubcsmbuatapi.bidgely.com";
export const API_PROTOCOL = "https://";
export const GA_TRACKING_ID = "UA-35481970-12";
export const MOUSEFLOW_PROJECT_ID = "be168703-f5a3-40a7-8258-5be1395431eb";